import { render, staticRenderFns } from "./VehicleViolationReport.vue?vue&type=template&id=372592bb&"
import script from "./VehicleViolationReport.vue?vue&type=script&lang=js&"
export * from "./VehicleViolationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports